import {Component, inject, OnInit} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {SidenavComponent} from "./layouts/sidenav/sidenav.component";
import {LanguageService} from "./shared/services/language.service";
import {HeaderComponent} from "./layouts/header/header.component";

import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import {DjangoApiService} from "./shared/services/django-api.service";
import {AuthService} from "./shared/services/auth.service";
import {DialogDisclaimerComponent} from "./shared/components/dialogs/dialog-disclaimer/dialog-disclaimer.component";
import {MatDialog} from "@angular/material/dialog";

registerLocaleData(localeDe, 'de');
registerLocaleData(localeEn, 'en');

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, SidenavComponent, DialogDisclaimerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent implements OnInit {
  readonly dialog = inject(MatDialog);
  test = 'test';

  private readonly storageKey = 'disclaimerAccepted';
  private readonly expirationMinutes = 1; // Gültigkeit: 1 Minute

  constructor(private languageService: LanguageService,
              private _apiService: DjangoApiService,
              private authService: AuthService,) {}

  ngOnInit() {

    if (!this.authService.isAuthenticated()) {
      this.checkDisclaimerStatus();
    }

    if (!this.languageService.isBot()) {
      this.languageService.initLanguage();
    }

    if (this.authService.isAuthenticated()) {
      this.authService.getUserInfo().subscribe({
        next: (info: any) => console.log('User info loaded:', info),
        error: (err: any) => console.error('Error loading user info', err)
      });
    } else {
      console.log('User is not authenticated, skip getUserInfo.');
    }


  }


  openDialog() {
    const dialogRef = this.dialog.open(DialogDisclaimerComponent, {
      disableClose: true,
      height: '600px',
      width: '600px',
    });

    dialogRef.afterClosed().subscribe(result => {
      this.acceptDisclaimer();
    });
  }

  private checkDisclaimerStatus(): void {
    const storedData = localStorage.getItem(this.storageKey);
    if (storedData) {
      try {
        const data = JSON.parse(storedData);
        const acceptedTime = new Date(data.acceptedTime);
        const currentTime = new Date();
        const diffMinutes = (currentTime.getTime() - acceptedTime.getTime()) / (1000 * 60);
        if (diffMinutes < this.expirationMinutes) {
          return;
        } else {
          this.openDialog()
          localStorage.removeItem(this.storageKey);
        }
      } catch (e) {
        console.error('Fehler beim Auslesen des Disclaimer-Status:', e);
        // Bei Fehlern wird der Dialog angezeigt
      }
    } else {
      this.openDialog()
    }
  }

  acceptDisclaimer(): void {
    const data = {
      acceptedTime: new Date().toISOString()
    };
    localStorage.setItem(this.storageKey, JSON.stringify(data));
  }

}
